import { type Row } from "@tanstack/react-table";
import { Column } from "@tanstack/table-core/src/types";

// We need to create a custom filter function to handle numbers because known tanstack bug https://github.com/TanStack/table/issues/4280
export const MagneticFilterFnWithNumSupport = <TData>(
  row: Row<TData>,
  columnId: string,
  filterValue: string
): boolean => {
  const isVisible = row
    .getVisibleCells()
    .some((cell) => cell.column.id === columnId);

  if (!isVisible) {
    return false;
  }

  const search = filterValue.toLowerCase();

  const value = row.getValue<string>(columnId)?.toString();

  return value?.toLowerCase().includes(search) ?? false;
};

// interface add-ons

MagneticFilterFnWithNumSupport.autoRemove = <TData>(
  val: string,
  // eslint-disable-next-line  @typescript-eslint/no-unused-vars
  _column?: Column<TData, unknown>
) => !val;
